import Chart from "react-apexcharts";

export const ChartDonut = ({ title='', labels = [], data = []}) => {


    let state = {
        options: {
            states: {
                hover: {
                    filter: {
                        type: 'none',
                    },
                },
            },
            labels: labels,
            title: {
                text: title,
            },
            colors: ['#7f56d9', '#8b66dc', '#9a79e1', '#a98ce6', '#b89feb', '#c7b2f0', '#d6c5f5', '#e5d8fa', '#f4ebff'],
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: false,
                width: 0,
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: '50%',
                    },
                },
            },
            legend: {
                position: 'left',
                horizontalAlign: 'center',
                width: 120,
                offsetY: 20,
                fontSize: '13px',
                markers: {
                    width: 13,
                    offsetX: -5,
                    offsetY: 1,
                    height: 13,
                    radius: 0,
                },
            },
        },
        series: data,
    };

    return (
        <Chart
            options={state.options}
            series={state.series}
            type="donut"
            height={300}
        />
    )
}
